<template>
  <datepicker
    class="date-picker-slim clickable"
    v-model="localValue"
    format="MM/dd/yy"
  ></datepicker>
</template>

<script>
import Datepicker from 'vuejs-datepicker';

export default {
  name: 'date-picker',

  props: ['value', 'onChange'],

  components: {
    Datepicker,
  },

  data() {
    return {
      localValue: this.value,
    };
  },

  methods: {
    clearDate() {
      this.localValue = null;
    },
  },
  watch: {
    localValue(val) {
      this.$emit('input', val);
      this.onChange(val);
    },
    value(val) {
      this.localValue = val;
    },
  },
};
</script>

<style lang="scss">
.date-picker-slim {
  position: absolute;
}

.date-picker-slim input {
  border: none !important;
  width: 5.5rem;
}

.date-picker-slim * {
  cursor: pointer !important;
}

.date-picker-slim .vdp-datepicker__calendar {
  width: 20rem;
}
</style>
